import { useTheme } from "@repo/tokens";

export const useStyles = () => {
  const { theme } = useTheme();
  const styles: Record<string, React.CSSProperties> = {
    containerStyles: {
      padding: theme.spacing.md,
      borderBottom: `${theme.borders.width.medium}px solid ${theme.border.divider}`,
    },
  };
  return styles;
};
